import React from 'react';

const BlockquoteOptions = ({ editor }) => {
  return (
    <div className="blockquoteOptions">
      <h3>Blockquote</h3>
      {/* Options will be added later */}
    </div>
  );
};

export default BlockquoteOptions;
